import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import MetrikaWrapper from './utils/MetrikaWrapper';
import ArbitrationLandingPage from './pages/ArbitrationLandingPage';
import Main2LandingPage from './pages/Main2LandingPage';
import VhodPage from './pages/VhodPage';
import NotFoundPage from './pages/NotFoundPage';
import BlogIndexPage from './pages/BlogIndexPage';
import BlogPostPage from './pages/BlogPostPage';
import { useAppVersionRefresh } from './hooks/useAppVersionRefresh';
import { initializeAttributionTracking } from './utils/attribution';

// import './assets/styles/Auth.css';

function AttributionTracker() {
  const location = useLocation();

  useEffect(() => {
    initializeAttributionTracking();
  }, [location.pathname, location.search, location.hash]);

  return null;
}

const App = () => {
  const { isUpdateAvailable, reloadApp, dismissUpdate } = useAppVersionRefresh();

  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <AttributionTracker />
          <Routes>
            <Route path="/" element={<MetrikaWrapper><Main2LandingPage /></MetrikaWrapper>} />
            <Route path="/bankrotstvo/" element={<MetrikaWrapper><ArbitrationLandingPage /></MetrikaWrapper>} />
            <Route path="/vhod/" element={<MetrikaWrapper><VhodPage /></MetrikaWrapper>} />
            <Route path="/blog/" element={<MetrikaWrapper><BlogIndexPage /></MetrikaWrapper>} />
            <Route path="/blog/:slug/" element={<MetrikaWrapper><BlogPostPage /></MetrikaWrapper>} />
            <Route path="/404/" element={<MetrikaWrapper><NotFoundPage /></MetrikaWrapper>} />
            <Route path="*" element={<MetrikaWrapper><NotFoundPage /></MetrikaWrapper>} />
          </Routes>
          <Dialog open={isUpdateAvailable} onClose={dismissUpdate}>
            <DialogTitle>Доступна новая версия</DialogTitle>
            <DialogContent>
              <DialogContentText>
                На сервере уже опубликована новая версия сайта. Можно обновить страницу сейчас или остаться на текущей.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={dismissUpdate}>Остаться</Button>
              <Button onClick={reloadApp} variant="contained" autoFocus>
                Перезагрузить
              </Button>
            </DialogActions>
          </Dialog>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
};

export default App;
